/* eslint-disable import/no-anonymous-default-export */
import { object, string, number, array, lazy } from "yup";
export default [
    object().shape({
      client_id:string().required("Client name is required"),
        case_details: object().shape({
            client_information: object().shape({
              // client: string().required("Client name is required"),
              // "client_file_no": string().required("File no is required"),
              // The mask leaves "_" in a half-typed number.
              phone_number: string().test("complete", "Enter the full phone number", (v) => !v?.includes("_")),
            }),
            assigment_information: object().shape({
                // investigator_name: string().required("Investigator is required"),
                // event: string().required("Event no is required"),
                supervisor_name: string().required("Client representative is required"),
              }),
        })

    }),
    object().shape({
        case_details: object().shape({
            client_information: object().shape({
                // budget: number().moreThan(0),
            }),
            case_information: object().shape({
                // "file_#": string().required("File no is required"),
                date_referred: string().required("Date refered is required"),
                // due_date: string().required("Due date is required"),
                case_type: string().required("Case type is required"),
        
                // sale_date: string().required("Sale date is required"),
              }),
            
        }),
        

    }),
    object().shape({
        case_details: object().shape({
            Subjects_information: array().of(
              lazy((subject) => subject?.subject_type === "business"
                ? object().shape({
                    business_name: string().required("Business name is required"),
                  })
                : object().shape({
                  first_name: string().required("First name is required"),
                  // middle_name: string().required("Middle name is required"),
                  last_name: string().required("Last name is required"),
                  // gender: string().required("Gender is required"),
                  // marital_status: string().required("Marital status is required"),
                  // phone: string().required("Phone number is required"),
                  
                //   ssn: string().required("SSN is required").min(11).max(11),
                  // dob: string().required("DOB is required"),
                }))
              ),
        }),
        

    }),

];